import { BrowserRouter, Routes, Route } from "react-router-dom";
import PricingPage from "@/pages/PricingPage";
import NotFound from "@/pages/notFound";
import Loader from "@/components/loader";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import Footer from "@/components/Footer";
import TenantThemeProvider from "@/components/tenantThemeProvider";
import TenantGate from "@/components/tenantGate";

export default function Router() {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <TenantThemeProvider />
      <TenantGate>
        <div className="relative w-full">
          <Routes>
            <Route index path="/" Component={PricingPage} />
            <Route index path="/checkout" Component={Checkout} />
            <Route index path="/confirmation" Component={Confirmation} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Loader />
          <Footer />
        </div>
      </TenantGate>
    </BrowserRouter>
  );
}
